<template lang="pug">
  #app(:class="{ 'is-authenticated': authenticated }")
    dx-aside
    #main-content
      router-view
</template>

<script>
import { mapGetters } from 'vuex';
import { Validator } from 'vee-validate';
import DxAside from '@/components/Aside';
import installRules from '@/utils/validators';
import * as getters from '@/store/types/getters';

installRules(Validator);

export default {
  name: 'app',
  computed: {
    ...mapGetters({
      authenticated: getters.GET_IS_AUTHENTICATED,
      snackbar: getters.GET_APP_SNACKBAR,
    }),
  },
  components: {
    DxAside,
  },
  data() {
    return {
      defaultSnackbar: {
        position: 'is-bottom-left',
        queue: true,
      },
    };
  },
  methods: {
    displaySnackbar(val) {
      if (val) {
        const options = Object.assign({}, this.defaultSnackbar, this.snackbar);
        this.$buefy.snackbar.open(options);
      }
    },
  },
  watch: {
    'snackbar.queued_at': 'displaySnackbar',
  },
};
</script>

<style src="vue-croppa/dist/vue-croppa.css"></style>
<style lang="scss">
  @import "~bulma/sass/utilities/_all";
  // Set your colors
  $primary: $theme-primary;
  $primary-invert: findColorInvert($primary);
  $success: $theme-success;
  $success-invert: findColorInvert($success);

  // Setup $colors to use as bulma classes (e.g. 'is-twitter')
  $colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
  );

  // Links
  $link: $primary;
  $link-invert: $primary-invert;
  $link-focus-border: $primary;
  @import "~bulma";
  @import "~buefy/src/scss/buefy";
</style>



// WEBPACK FOOTER //
// src/App.vue